export const validateForms = (fileInputs) => {
    const errors = [];
  
    fileInputs.forEach(({ docNumber, file, quantity, paperFormat, printOption }) => {
      const errorObj = { docNumber };
  
      // Validate file
      if (!file) {
        errorObj.fileError = "File is required.";
      }
  
      // Validate quantity (should be a positive integer)
      if (!quantity || quantity < 1) {
        errorObj.quantityError = "Quantity must be at least 1.";
      }
  
      // Validate paperFormat (should not be empty)
      if (!paperFormat) {
        errorObj.paperFormatError = "Print format is required.";
      }
  
      // Validate printOption (should not be empty)
      if (!printOption) {
        errorObj.printOptionError = "Print option is required.";
      }
  
      // If there are any errors for this document, add the object to the errors array
      if (Object.keys(errorObj).length > 1) { // More than just docNumber present
        errors.push(errorObj);
      }
    });
  
    return errors;
  };

export const validateCheckoutForm = (formData) => {
    const errors = {};

    // Validate user Name
    if (!formData.name) {
      errors.name = 'Name is required.';
    }
    // Validate user Email
    if (!formData.email) {
      errors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Invalid email format.';
    }
    // Validate user Phone Number
    if (!formData.phone) {
      errors.phone = 'Phone number is required.';
    } else if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = 'Invalid phone number format. Please enter a 10-digit number.';
    }
    // Validate Payment Method
    if (!formData.paymentMethod) {
      errors.paymentMethod = 'Payment method is required.';
    }
    return errors;
}